"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapVerifyTrustedLoginSession = void 0;
const mapVerifyTrustedLoginSession = (verifyTrustedLoginResponse) => {
    const { accessToken, refreshToken, sessionExpiresAt, expiresIn } = verifyTrustedLoginResponse;
    return {
        accessToken,
        refreshToken,
        expiresIn,
        sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
        username: '',
    };
};
exports.mapVerifyTrustedLoginSession = mapVerifyTrustedLoginSession;
//# sourceMappingURL=mapper.js.map